module.exports = __webpack_public_path__ + "img/icon-print.6816f1a8.svg";